export default function TestimonialSection() {
  return (
    <section id="opinie" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-900 rounded-2xl overflow-hidden p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="w-full lg:w-2/5 flex-shrink-0">
              <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Polish%20business%20person%20portrait%20with%20warm%20neutral%20beige%20background%2C%20modern%20casual%20style%20clothing%2C%20natural%20soft%20lighting%2C%20clean%20minimalist%20portrait%20photography%2C%20friendly%20confident%20expression%2C%20editorial%20quality%2C%20shallow%20depth%20of%20field%2C%20warm%20earthy%20tones&width=600&height=800&seq=testimonial-portrait-2026&orientation=portrait"
                  alt="Opinia o USFansSpreadsheet"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex-1 text-left">
              <div className="text-accent-400 text-5xl md:text-6xl font-serif leading-none mb-4">&ldquo;</div>
              <blockquote className="text-base md:text-lg text-background-100 leading-relaxed mb-6">
                USFansSpreadsheet to absolutnie najlepsze narzędzie, z jakiego korzystałem do porównywania produktów z USA. Dzięki niemu zaoszczędziłem setki godzin na ręcznym przeszukiwaniu ofert. Regularne aktualizacje i pełny zakres kategorii – od Shoes po Perfumes – sprawiają, że jest to niezbędne narzędzie dla każdego fana amerykańskich produktów w Polsce.
              </blockquote>
              <div className="mb-6">
                <p className="text-background-100 font-semibold text-sm">Michał Kowalski</p>
                <p className="text-background-400 text-xs mt-0.5">Analityk narzędzi internetowych, 5 lat doświadczenia</p>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-background-50 text-sm font-medium rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Sprawdź teraz
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}